enum OfficeEventType {
	AVAILABLE = 'AVAILABLE',
	UNAVAILABLE = 'UNAVAILABLE',
	SOFT_BLOCK = 'SOFT_BLOCK',
}

export default OfficeEventType;
